import { useRef, useEffect, useState } from "react";

import "./style.scss";

const Modal = ({ children, open = false, onRequestClose = () => {} }) => {
  const modalContainer = useRef();
  //   const [open, setOpen] = useState(isOpen);

  useEffect(() => {}, []);

  return open ? (
    <div className="modalContainer" ref={modalContainer}>
      <div className="overlay"></div>
      <div className="contentContainer">
        {children}
        <div className="close" onClick={onRequestClose}>
          &times;
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Modal;
